import { createRootRoute, Outlet } from "@tanstack/react-router";
import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "sonner";
/*
import { AuthProvider } from "@/contexts/AuthContext";

<AuthProvider>
</AuthProvider>
*/

function RootComponent() {
  return (
    <ThemeProvider>
      <Outlet />
      <Toaster />
    </ThemeProvider>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
});
